export default __webpack_public_path__ + "static/media/sale.8a3bcac8.png";